module.exports = __webpack_public_path__ + "a57960917a142f344d657dd587221434.png";